export default "__VITE_ASSET__DLwV25Wn__"